<template>
  <div class=" w-full mx-auto" v-if="settings.accountId !== '' && settings.placementId !== ''">
    <Jellybeans v-if="settings.initialized" />
    <div v-else-if="settings.error" class="flex flex-col">
      <h2 class="text-xl">Jellybeans</h2>
      <p>No Settings found.</p>
    </div>
  </div>
  <div v-else class=" w-full mx-auto">
    <div class="flex flex-col">
      <h2 class="text-xl">Jellybeans</h2>
      <p>Placement properties not set.</p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import Jellybeans from './components/Jellybeans.vue'
import { useSettingsStore } from './stores/settings'

const settings = useSettingsStore()

onMounted(async () => {
  if (settings.accountId !== '') {
    await settings.fetchSettings()
  }
})
</script>

<style scoped></style>
